<template>
  <div class="qualification">
    <h3 class="education_tit">Education</h3>
    <ul class="education clearfix">
      <li class="clearfix">
        <div>
          <h3 class="tile_name">Highest Level of Education*</h3>
          <el-select
            v-model="basic_info.educational_attainment"
            filterable
            disabled
          >
            <el-option
              v-for="(key,val) of data_config.educational_attainment"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            v-show='!f_state.inp1'
            class="state_notice"
          >This is required.</p>
        </div>
        <div class="input_info marginR">
          <h3 class="tile_name">School Name*</h3>
          <el-select
            v-model="basic_info.school_name"
            :remote-method="schoolSearch"
            :loading="schoolNameSearchLanding"
            filterable
            remote
            placeholder="Please Search School Name *"
          >
            <el-option
              v-for="(key,val) of searchSchool"
              :label='key'
              :value="key"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            v-show='!f_state.inp2'
            class="state_notice"
          >This is required.</p>
        </div>
      </li>
      <li class="clearfix">
        <div>
          <h3 class="tile_name">Major / Specialization*</h3>
          <el-select
            v-model="basic_info.major"
            filterable
          >
            <el-option
              v-for="(key,val) of data_config.majors"
              :label="val"
              :value="key"
              :key="key"
            >
            </el-option>
          </el-select>
          <p
            v-show='!f_state.inp3'
            class="state_notice"
          >This is required.</p>
        </div>
      </li>
      <li class="clearfix">
        <h3 class="tile_name">{{basic_info.teaching_certification.certification_academic.name}}</h3>

        <ul class="img_list clearfix">
          <li
            v-for="(item, index) of basic_info.teaching_certification.certification_academic.data"
            :key="index"
          >
            <i
              class="del el-icon-circle-close"
              v-if="item.cert_url"
              @click="delUpload({
                key: 'certification_academic',
                index: index
              })"
            ></i>
            <file-upload
              :action="action"
              :before-upload="beforeUpload"
              @complete="uploadComplete"
              :uploadKey="{
                key: 'certification_academic',
                index: index
              }"
            >
              <uploadImg
                message="Upload proof"
                :imageUrl="item.cert_url"
              ></uploadImg>
            </file-upload>
            <p>{{item.cert_name}}</p>
          </li>
        </ul>
      </li>
    </ul>
    <h3 class="education_tit">Teaching Experience</h3>
    <div class="education clearfix education-experience">
      <div>
        <h3 class="tile_name">What kind of experience do you have with K-12 education in the US and/or Canada?</h3>
        <el-select
          v-model="basic_info.teaching_experience"
          filterable
          multiple
          disabled
        >
          <el-option
            v-for="(key,val) of data_config.teaching_experience"
            :label="key"
            :value="val"
            :key="val"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <ul
      class="education clearfix"
      v-if="basic_info.total_teaching_experience.length > 0"
    >
      <li class="clearfix">
        <div>
          <h3 class="tile_name">In total how much teaching experience do you have?</h3>
          <el-select
            v-model="basic_info.total_teaching_experience"
            filterable
            disabled
          >
            <el-option
              v-for="(key,val) of data_config.total_teaching_experience"
              :label="key.option_value"
              :value="key.option_key"
              :key="val"
            >
            </el-option>
          </el-select>
        </div>
      </li>
    </ul>

    <ul class="education education-experience-list clearfix">
      <li
        class="clearfix"
        v-for="(item, index) of datas.teaching_experience_list"
        :key="index"
      >
        <div>
          <h3 class="tile_name">Organization Name</h3>
          <input
            v-model.trim="item.organization_name"
            type="text"
            disabled
          />
        </div>
        <div>
          <h3 class="tile_name">Job Title</h3>
          <input
            :value="item.job_title in data_config.job_title ? data_config.job_title[item.job_title] : item.job_title"
            type="text"
            disabled
          />
        </div>
        <div>
          <h3 class="tile_name">Time period</h3>
          <el-select
            v-model="item.period_teaching_experience"
            filterable
            disabled
          >
            <el-option
              v-for="(key,val) of data_config.period_teaching_experience"
              :label="key.option_value"
              :value="key.option_key"
              :key="val"
            >
            </el-option>
          </el-select>
        </div>
      </li>
    </ul>

    <h3 class="education_tit">Teaching certificates:</h3>
    <div class="teaching-main clearfix">
      <div
        class="teaching-text"
        v-for="(certification, certificationKey) of basic_info.teaching_certification"
        :key="certificationKey"
        v-show="certificationKey !== 'certification_academic'"
      >
        <h6>{{certification.name}}:</h6>

        <ul class="img_list clearfix">
          <li
            v-for="(item, index) of certification.data"
            :key="index"
          >
            <i
              class="del el-icon-circle-close"
              v-if="item.cert_url"
              @click="delUpload({
                key: certificationKey,
                index: index
              })"
            ></i>
            <file-upload
              :action="action"
              :before-upload="beforeUpload"
              @complete="uploadComplete"
              :uploadKey="{
                key: certificationKey,
                index: index
              }"
            >
              <uploadImg
                message="Upload proof"
                :imageUrl="item.cert_url"
              ></uploadImg>
            </file-upload>
            <p>{{item.cert_name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <p class="save">
      <a
        :class='{cancel: !isCancel}'
        @click='save'
      >Save</a>
    </p>
  </div>
</template>

<script>
import uploadImg from "@common/upload_img";
import fileUpload from "@common/file_upload";
import basePath from "@api/basePath";

export default {
  props: {},
  data() {
    return {
      data_config: "",
      data_t_d: "",
      fileList: [],
      upload_file_wid: "490",
      f_state: {
        inp1: false,
        inp2: false,
        inp3: false
      },

      basic_info: {
        educational_attainment: "",
        teaching_experience_list: [],
        school_name: "",
        major: "",
        teaching_experience: [],
        years: "",
        total_teaching_experience: "",
        teaching_certificate: [],
        // 上传证书集合
        teaching_certification: {
          certification_tesol: {
            name: "TESOL",
            data: []
          },
          certification_teyl: {
            name: "TEYL",
            data: []
          },
          certification_other: {
            name: "Other Certificate",
            data: []
          },
          certification_academic: {
            name:
              "Please upload your highest attained diploma(Bachelor’s, Master’s, Doctoral)*",
            data: []
          }
        }
      },

      schoolNameSearchLanding: false, //搜索school name
      searchSchool: {},
      SchollNameVal: ""
    };
  },
  created() {
    /*请求基本信息*/
    this.$http.get("/common/getConfig").then(
      response => {
        if (response.data && response.data.code == "75000") {
          let res = response.data.res;
          for (let key in res.majors) {
            res.majors[key] = res.majors[key] + "";
          }
          this.data_config = response.data.res;

          /*初始化页面数据*/
          this.$http.get("/Boarding/getTutor").then(function(d) {
            if ((d.data.code = "75000")) {
              this.data_t_d = d.data.res.info;

              // 合并已有证书数据 生成上传配置
              let teaching_certification =
                d.data.res.info.teaching_certification;

              for (let [key, value] of Object.entries(
                this.basic_info.teaching_certification
              )) {
                let config = res[key];

                for (let [cert_code, cert_name] of Object.entries(config)) {
                  // 上传证书地址
                  let cert_url = "";

                  if (teaching_certification && teaching_certification[key]) {
                    let findItem = teaching_certification[key].find(
                      item => item.cert_code == cert_code
                    );

                    if (findItem && findItem.cert_url) {
                      // 如果已有数据的证书地址不为空
                      cert_url = findItem.cert_url;
                    }
                  }

                  value.data.push({
                    cert_code,
                    cert_name,
                    cert_url
                  });
                }
              }

              // console.log(this.basic_info.teaching_certification);

              var arr = [
                "educational_attainment",
                "school_name",
                "major",
                "teaching_experience",
                "total_teaching_experience",
                "teaching_certificate",
                "teaching_experience_list"
              ]; //vue数据

              var arrs = [
                "educational_attainment",
                "university",
                "major",
                "teaching_experience",
                "total_teaching_experience",
                "teaching_certificate",
                "teaching_experience_list"
              ]; //从后端数据api取出的数据

              for (var i = 0; i < arr.length; i++) {
                if (this.datas[arrs[i]]) {
                  this.basic_info[arr[i]] = ["teaching_experience"].includes(
                    arrs[i]
                  )
                    ? this.datas[arrs[i]].split(",")
                    : this.datas[arrs[i]];
                }
              }
            }
          });
        }
      },
      function() {
        console.log("service error");
      }
    );
  },
  components: {
    uploadImg,
    fileUpload
  },
  computed: {
    teaching_certificate: {
      get() {
        return this.basic_info.teaching_certificate;
      },
      set(val) {
        let lastVal = val.slice(-1)[0];
        let key = "11";
        if (lastVal === key) {
          this.basic_info.teaching_certificate = [key];
        } else {
          let index = val.indexOf(key);
          if (index > -1) {
            val.splice(index, 1);
          }

          this.basic_info.teaching_certificate = val;
        }
      }
    },
    count() {
      return this.$store.state.count;
    },
    action() {
      return `${basePath}/Fileupload/uploadToHkOss`;
    },
    isCancel() {
      let pass;

      for (let opt in this.f_state) {
        if (this.f_state[opt]) {
          pass = true;
        } else {
          pass = false;
          break;
        }
      }

      return pass;
    },
    datas: function() {
      let data = {}; // 最后得到的数据
      let inpKey = [
        "university",
        "esl_teaching_years",
        "certificate_url",
        "educational_attainment",
        "major",
        "teaching_experience",
        "total_teaching_experience",
        "teaching_experience_list",
        "teaching_certificate"
      ];

      let second_step_key = [];

      //this.data_config
      //第一次循环，得到直接可以拿到的数据
      for (let key of inpKey) {
        if (!this.data_t_d[key] && key !== "major") {
          //"0","",undefined，值都为空  majors字段特殊，0为对应值，忽略掉
          data[key] = "";
        } else {
          data[key] = this.data_t_d[key];
        }
      }

      return data;
    }
  },
  methods: {
    // 证书上传成功
    uploadComplete(response, file, idx, id, { key, index }) {
      if (response.code == 75000) {
        this.$message.success("Congratulations, upload success!");
        this.basic_info.teaching_certification[key].data[index].cert_url =
          response.res.url;
      } else {
        this.$message.error("service error");
      }
    },
    // 上传之前
    beforeUpload(file, event) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(
          "Upload avatar image can only be JPG and PNG format!"
        );
      }
      if (!isLt2M) {
        this.$message.error("Upload avatar picture size no more than 2 MB.");
      }
      return isJPG && isLt2M;
    },
    // 删除证书
    delUpload({ key, index }) {
      this.$confirm("Delete this item?")
        .then(() => {
          this.basic_info.teaching_certification[key].data[index].cert_url = "";
        })
        .catch(() => {});
    },
    save() {
      if (!this.isCancel) return;

      const teaching_certification = {};

      for (let [certificationKey, certification] of Object.entries(
        this.basic_info.teaching_certification
      )) {
        const certificationData = certification.data
          .filter(({ cert_url }) => cert_url)
          .map(({ cert_code, cert_url }) => ({ cert_code, cert_url }));

        if (certificationData.length > 0) {
          teaching_certification[certificationKey] = certificationData;
        }
      }

      const formdata = {
        university: this.basic_info.school_name,
        major: this.basic_info.major
      };

      if (Object.keys(teaching_certification).length > 0) {
        Object.assign(formdata, {
          teaching_certification
        });
      }

      this.axios.post("/Boarding/addQualific", formdata).then(
        d => {
          if (d && d.data.code == "75000") {
            this.$message.success("save success.");
            this.$router.replace("/personal_profile/payment");
          } else {
            this.$message.error(d.data.message);
          }
        },
        () => {
          this.$message.error("service error");
        }
      );
    },
    doc_up_s_fn(response, file, fileList) {
      if (response.code == 75000) {
        this.$message.success("Upload successful!");

        this.words = file.raw.name;
      } else {
        this.$message.error("Upload failed.");
      }
    },
    doc_before_up(file) {
      const isDoc =
        file.type === "application/pdf" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/msword";
      //以下是文件类型对应的type String
      //application/pdf .pdf
      //application/vnd.openxmlformats-officedocument.wordprocessingml.document .docx
      //application/msword   .doc

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isDoc) {
        this.$message.error("Only upload documents'type of .doc/.docx/.pdf!");
      }
      if (!isLt2M) {
        this.$message.error("Upload avatar picture size no more than 2 MB.");
      }

      return isDoc && isLt2M;
    },
    schoolSearch(val) {
      if (val !== "") {
        this.schoolNameSearchLanding = true;
        this.axios.get("/common/getUniversityList?name=" + val).then(
          d => {
            if (d.data.code == 75000) {
              this.searchSchool = d.data.res;
              this.schoolNameSearchLanding = false;
            }
          },
          () => {
            console.log("error");
          }
        );
      } else {
        this.searchSchool = {};
      }
    }
  },
  watch: {
    // 表单监测
    basic_info: {
      handler: function(o, n) {
        this.basic_info.years = this.basic_info.years.replace(/[^\d\.]+/g, "");

        this.basic_info.school_name = this.basic_info.school_name
          .replace(/[^a-zA-z0-9\s]+/g, "")
          .replace(/\^/g, "");

        this.f_state.inp1 = !this.basic_info.educational_attainment
          ? false
          : true;
        this.f_state.inp2 = !this.basic_info.school_name ? false : true;
        this.f_state.inp3 = !this.basic_info.major ? false : true;
      },
      deep: true
    }
  }
};
</script>

<style lang='less' scoped>
.qualification {
  width: 1000px;
  input {
    outline: none;
  }
  .education_tit {
    height: 40px;
    width: 100%;
    font-weight: bold;
    float: none;
    text-align: left;
  }
  .education {
    width: 1000px;
    margin-bottom: 30px;
    & > div {
      width: 100%;
      float: left;
      margin-right: 20px;
    }
    > li {
      margin-bottom: 20px;
      & > div {
        float: left;
        margin-right: 20px;
        width: 490px;
      }
    }
    .marginR {
      margin-right: 0;
    }
    .input_info {
      margin-right: 0;
      input {
        width: 492px;
        padding: 0 10px;
        height: 38px;
        border: 1px solid #ccc;
        border-radius: 10px;
      }
      input:focus {
        border-color: #fcc800;
      }
    }
  }
  .background_list {
    li {
      padding: 0 14px;
      height: 33px;
      line-height: 33px;
      margin-right: 10px;
      border: 1px solid #fcc800;
      color: #ffb400;
      margin-bottom: 25px;
      float: left;
      font-weight: bold;
      border-radius: 10px;
      cursor: pointer;
      font-size: 14px;
      &.active {
        background-color: #fcc800;
        color: #1e1e1e;
      }
    }
  }
  select,
  input {
    box-sizing: border-box;
    width: 488px;
    height: 38px;
    padding-left: 15px;
    border: 1px solid #cccccc;
    border-radius: 10px;
    outline: none;

    &:disabled {
      cursor: not-allowed;
      background-color: #eef1f6;
      color: #bbb;
    }
  }
  select {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: url("~@img/select_r_bg.png") no-repeat 437px -1px;
  }
  .el-input__inner:focus {
    border-color: #fcc800;
  }
  .el-input__inner:hover {
    border-color: #ccc;
  }
  .img_list {
    margin-left: -46px;

    li {
      position: relative;
      overflow: hidden;
      margin-left: 46px;
      margin-bottom: 20px;
      float: left;

      p {
        text-align: center;
        margin-top: 10px;
        font-size: 14px;
        color: #666;
      }

      &:hover {
        .del {
          visibility: visible;
          opacity: 1;
          // right: 5px;
          // top: 5px;
          transform: rotate(0deg);
        }
      }

      .del {
        font-size: 20px;
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 10;
        cursor: pointer;
        color: #fd4c6e;
        visibility: hidden;
        opacity: 0;
        transition: all 0.3s;
        transform: rotate(-90deg);
      }
    }
  }

  .save {
    text-align: center;
    margin-top: 80px;
    margin-bottom: 174px;
    a {
      color: #1e1e1e;
      width: 337px;
      height: 46px;
      line-height: 46px;
      background-color: #fcc800;
      font-size: 24px;
      display: inline-block;
      border-radius: 10px;
      cursor: pointer;
      &.cancel {
        background: #cccccc;
        color: #fff;
        cursor: default;
      }
    }
  }
  p.state_notice {
    padding: 5px 0 5px 15px;
    color: #fd4c6e;
    font-size: 14px;
  }

  .education-experience-list {
    li {
      > div {
        width: 22%;

        input {
          width: 100%;
        }
      }
    }
  }
}
.file_upload_input > div p {
  padding-left: 10px;
  color: #1e1e1e;
}

.tile_name {
  font-size: 16px;
  color: #999;
  height: 20px;
  line-height: 1;
  margin-bottom: 5px;
}
</style>
<style lang='less'>
.education {
  & > div {
    width: 490px;
  }
}
div.el-select {
  width: 100%;
  div.el-input {
    input.el-input__inner {
      height: 38px;
      border-radius: 10px;
      border: 1px solid #cccccc;
      &:focus {
        border-color: #fcc800;
      }
    }
  }
}

.education-experience .el-tag .el-icon-close {
  visibility: hidden;
}

.teaching-main {
  .teaching-text {
    overflow: hidden;

    h6 {
      line-height: 35px;
      font-weight: bold;
      color: #999;
      margin-bottom: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// personal_qa.vue?46e2d117